<template>
  <section class="max-w-xl mx-auto">
    <SearchAndFilter v-model="queryString" />
    <ContentSectionLoader v-if="loading" />
    <template v-else>
      <MembershipsTable :memberships="memberships.data" />
      <Pagination
        :on-change="handlePageChange"
        :pagination="memberships.meta.pagination"
      />
      <div class="text-center my-6">
        <button
          type="button"
          class="btn"
          :disabled="selectedMemberships.length === 0"
          :aria-disabled="selectedMemberships.length === 0"
          @click="nextTab"
          v-text="buttonText"
        />
      </div>
    </template>
  </section>
</template>

<script type="text/babel">
import URI from 'urijs'
import { mapActions, mapState } from 'vuex'
import SearchAndFilter from 'Membership/Resources/assets/js/components/SearchAndFilter'
import Pagination from 'Base/Resources/assets/js/components/Pagination'
import TabNavigation from 'Membership/Resources/assets/js/mixins/tab-navigation'
import MembershipsTable from 'Membership/Resources/assets/js/components/bulk-edit/MembershipsTable'

export default {
  name: 'SelectMemberships',
  components: {
    MembershipsTable,
    SearchAndFilter,
    Pagination,
  },
  mixins: [TabNavigation],
  data() {
    return {
      queryString: {
        query: '',
        page: 1,
        filter: 'all',
      },
      loading: true,
    }
  },
  computed: {
    ...mapState({
      memberships: state => state.membership.memberships,
      selectedMemberships: state => state.membership.selectedMemberships,
    }),
    buttonText() {
      if (this.selectedMemberships.length === 0) {
        return 'Continue'
      }

      return this.selectedMemberships.length === 1
        ? 'Continue (1)'
        : `Continue (${this.selectedMemberships.length})`
    },
    fetchUrl() {
      return new URI('').setSearch(this.queryString).toString()
    },
  },
  watch: {
    queryString: {
      handler: _.debounce(function () {
        history.pushState(null, null, this.fetchUrl)

        this.fetchMemberships()
      }, 500),
      deep: true,
    },
  },
  async mounted() {
    await this.$nextTick()

    this.queryString = Object.assign(this.queryString, new URI().query(true))

    this.fetchMemberships()
  },
  methods: {
    ...mapActions({
      getMemberships: 'membershipGetMemberships',
    }),
    fetchMemberships() {
      this.loading = true

      this.getMemberships({ params: {
        ...this.queryString,
        include: 'membershipGroups',
        per_page: 50,
      }}).then(() => {
        this.loading = false
      })
    },
    handlePageChange(page) {
      this.queryString.page = page

      this.fetchMemberships()
    },
  },
}
</script>
